import { CampaignSource, CampaignSubSource } from 'utils/constants/campaign';
import { VIEW_DATE_WITHOUT_DAY_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

import 'components/Admin/Reports/IncomeExpenseReport/IncomeExpenseTable/IncomeExpenseReport.less';

const INCOME_EXPENSE_HEADERS = [
    CampaignSubSource.HH,
    CampaignSubSource.VK,
    CampaignSubSource.Direct,
    CampaignSource.Yandex,
    CampaignSubSource.Adwords,
    CampaignSubSource.Social,
    CampaignSubSource.Instagram,
    CampaignSubSource.Facebook,
    CampaignSource.VKAds,
];

const IncomeExpenseTable = () => {
    const incomeExpenseData = useSelector((state) => state.incomeExpense.incomeExpenseData);

    const trl = useTrls();

    return (
        <Table fullWidth withStripes bordered>
            <TableHead>
                <TableRow>
                    <TableHeadCell className="income-expense-month">
                        {trl('admin.IncomeExpenseReport.month')}
                    </TableHeadCell>
                    <TableHeadCell>
                        {trl('admin.IncomeExpenseReport.Income.total')}
                        {trl('admin.IncomeExpenseReport.currency')}
                    </TableHeadCell>
                    <TableHeadCell>
                        {trl('admin.IncomeExpenseReport.Expense.total')}
                        {trl('admin.IncomeExpenseReport.currency')}
                    </TableHeadCell>
                    {INCOME_EXPENSE_HEADERS.map((header) => (
                        <TableHeadCell key={header}>
                            {trl(`admin.IncomeExpenseReport.Expense.${header.toLowerCase()}`)}
                            {trl('admin.IncomeExpenseReport.currency')}
                        </TableHeadCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {incomeExpenseData.map((incomeExpense) => (
                    <TableRow key={incomeExpense.date}>
                        <TableCell>{formatDate(incomeExpense.date, VIEW_DATE_WITHOUT_DAY_FORMAT)}</TableCell>
                        <TableCell>{incomeExpense.incoming || 0}</TableCell>
                        <TableCell>{incomeExpense.expense || 0}</TableCell>
                        {INCOME_EXPENSE_HEADERS.map((header) => (
                            <TableCell key={header}>{incomeExpense.sources[header] || 0}</TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default IncomeExpenseTable;
